import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Routes, Route, BrowserRouter, Outlet } from "react-router-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
// import "./style/pfapp.scss";

import Fax from "pages/Fax";
import Login from "pages/Login";
import Patient from "pages/Patient";
import Location from "pages/Location";
import Providers from "pages/Providers";
import NotValidTab from "pages/NotValidTab";
import ClaimsManager from "pages/ClaimsManager";
import Configuration from "pages/Configuration";
import Invoice from "pages/Invoice";
import { PrivateRoute } from "routes/privateRoute";
import TaskBoard from "pages/TaskBoard";
import axios from "axios";
import { ModuleAccess } from "utils/moduleaccess";
import Dashboard from "pages/Dashboard";

const App = () => {
  const [modules, setModules] = useState([]);
  const [orgId, setOrgId] = useState(window.selectedOrganizationId);
  const onOrgChange = (orgId) => {
    setOrgId(orgId);
  };

  const fetchModules = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const { sub } = profile || {};
    try {
      if (access_token) {
        renderCLM();
        renderPatientClaims();
        renderConfiguration();
        renderFax();
        renderINV();
        renderLocation();
        renderProviders();
        renderTaskBoard();
        renderDashboard();
      }

      // const { data } = await axios.get(
      //   `${process.env.REACT_APP_ENDPOINT}/RCMConfig/app/modules`,
      //   {
      //     //params: { Id: sub },
      //     headers: {
      //       'Content-type': 'application/json',
      //       Authorization: `${token_type} ${access_token}`,
      //     },
      //   }
      // );
      // if (data) {
      //   setModules(data);
      // }
    } catch (error) {
      console.log(error.message);
    }
  };

  const ThemeSelector = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const { sub } = profile || {};
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/RCMConfig/app/userapptheme`,
        {
          //params: { Id: sub },
          headers: {
            "Content-type": "application/json",
            Authorization: `${token_type} ${access_token}`,
          },
        }
      );
      if (data) {
        import("./style/pfapp.scss");
        sessionStorage.setItem("theme", data);
        // if (data === "PF") {
        //   import("./style/pfapp.scss");
        // } else if (data === "CPS") {
        //   import("./style/app.scss");
        // }
      }
    } catch (error) {
      console.log(error.message);
    }

    return <></>;
  };

  useEffect(() => {
    ThemeSelector();
    fetchModules();
  }, []);
  const renderDashboard = () => {
    if(ModuleAccess("DB","")){
    return <Route path="/dashboard" element={<Dashboard  module={module[0]}  orgId={orgId} />} 
    />;
    }
  };
  const renderCLM = () => {
    //let module = modules.filter(m => m.code == "CLM")
    //if (module.length > 0)
    if (ModuleAccess("CLM", ""))
      return (
        <Route
          path="/claims-manager"
          element={<ClaimsManager module={module[0]} orgId={orgId} />}
        />
      );
  };
  const renderPatientClaims = () => {
    //let module = modules.filter(m => m.code == "CLM")
    if (ModuleAccess("CLM", "")) {
      //if (module[0].actions.indexOf('PC') > -1)
      if (ModuleAccess("CLM", "PC")) {
        return (
          <Route
            path="/claims-manager/:coveredEntityID/:tenantID/:isfax/patient/:patientId"
            element={<Patient module={module[0]} orgId={orgId} />}
          />
        );
      }
    }
  };
  const renderProviders = () => {
    //let module = modules.filter(m => m.code == "PRD")
    if (ModuleAccess("PRD", ""))
      return (
        <Route
          path="/providers"
          element={<Providers module={module[0]} orgId={orgId} />}
        />
      );
  };
  const renderFax = () => {
    //let module = modules.filter(m => m.code == "FAX")
    if (ModuleAccess("FAX", ""))
      return (
        <Route path="/fax" element={<Fax module={module[0]} orgId={orgId} />} />
      );
  };

  const renderLocation = () => {
    //let module = modules.filter(m => m.code == "SL")
    if (ModuleAccess("SL", ""))
      return (
        <Route
          path="/location"
          element={<Location module={module[0]} orgId={orgId} />}
        />
      );
  };

  const renderConfiguration = () => {
    //let module = modules.filter(m => m.code == "CON")
    if (ModuleAccess("CON", ""))
      return (
        <Route
          path="/configuration"
          element={<Configuration module={module[0]} orgId={orgId} />}
        />
      );
  };

  const renderLogin = () => {
    return <Route index element={<Login />} />;
    if (false)
      return (
        <>
          <Route index element={<Login />} />
          <Route index path="/login" element={<Login />} />
        </>
      );
  };
  const renderINV = () => {
    //let module = modules.filter(m => m.code == "INV")
    if (ModuleAccess("INV", ""))
      return (
        <Route
          path="/Invoice"
          element={<Invoice module={module[0]} orgId={orgId} />}
        />
      );
  };

  const renderTaskBoard = () => {
    //let module = modules.filter(m => m.code == "TB");
    if (ModuleAccess("TB", "")) {
      return (
        <Route path="/taskboard" element={<TaskBoard module={module[0]} orgId={orgId} />} />
      );
    }
  };

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<Outlet />}>
            <Route
              element={
                <PrivateRoute modules={modules} onAppOrgChange={onOrgChange} />
              }
            >
              {renderLogin()}
              {renderDashboard()}
              {renderTaskBoard()}
              {renderCLM()}
              {renderProviders()}
              {renderFax()}
              {renderPatientClaims()}
              {renderLocation()}
              {renderConfiguration()}
              {renderINV()}
            </Route>

            {/* catch all */}
            <Route path="*" element={<NotValidTab />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default App;
